import { historyIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Activity = createIcon({
  displayName: 'Activity',
  paths: [
    'M426.645 853.342c-15.147 0-29.355-8.107-37.035-21.504l-158.379-277.163h-103.253c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h128c15.317 0 29.44 8.192 37.077 21.504l120.405 210.731 142.848-499.968c4.693-16.512 18.859-28.544 35.883-30.635 16.853-2.091 33.664 6.315 42.197 21.205l158.379 277.163h103.211c23.595 0 42.667 19.115 42.667 42.667s-19.072 42.667-42.667 42.667h-128c-15.275 0-29.397-8.192-37.035-21.504l-120.405-210.731-142.848 499.968c-4.693 16.512-18.859 28.544-35.883 30.635-1.707 0.213-3.456 0.299-5.163 0.299z'
  ],
  canvasPaths: canvasIconPaths(historyIcon)
})
